// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import Enums from '../Enums';

export class ForecastStatusAgg {
  readonly projectStatusId: string;
  readonly projectStatusName: string;
  readonly projectCount: string;
  readonly totalProject: string;
  readonly totalProjectUnit: Enums.Unit;

  constructor(data: { [key: string]: any } = {}) {
    this.projectStatusId = data.projectStatusId === undefined ? NIL_UUID : data.projectStatusId;
    this.projectStatusName = data.projectStatusName === undefined ? '' : data.projectStatusName;
    this.projectCount = data.projectCount === undefined ? '0' : data.projectCount;
    this.totalProject = data.totalProject === undefined ? '0' : data.totalProject;
    this.totalProjectUnit =
      data.totalProjectUnit === undefined ? Enums.Unit.CuYd : data.totalProjectUnit;
  }

  static zero(): ForecastStatusAgg {
    const zeroValues: ExcludeMethodsDeep<ForecastStatusAgg> = {
      projectStatusId: NIL_UUID,
      projectStatusName: '',
      projectCount: '0',
      totalProject: '0',
      totalProjectUnit: Enums.Unit.CuYd,
    };
    return new ForecastStatusAgg(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type ForecastStatusAggWireFormat = {
  projectStatusId: string;
  projectStatusName: string;
  projectCount: string;
  totalProject: string;
  totalProjectUnit: string;
};

type NewForecastStatusAggProps = PartialDeep<ForecastStatusAgg, { recurseIntoArrays: true }>;
export const NewForecastStatusAgg: (props: NewForecastStatusAggProps) => ForecastStatusAgg = (
  props,
) => new ForecastStatusAgg(props);

type NewForecastStatusAggFromWireFormatProps = PartialDeep<
  ForecastStatusAggWireFormat,
  { recurseIntoArrays: true }
>;
export const NewForecastStatusAggFromWireFormat: (
  props: NewForecastStatusAggFromWireFormatProps,
) => ForecastStatusAgg = (props) => new ForecastStatusAgg(props);
